import { BrowserRouter, Route, Routes } from "react-router-dom";
import "@/App.css";
import { SmoothScroll } from "@/components/SmoothScroll";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { Home } from "@/pages/Home";
import { ServicePage } from "@/pages/ServicePage";
import { CasePage } from "@/pages/CasePage";
import { StudioPage } from "@/pages/StudioPage";
import { FounderPage } from "@/pages/FounderPage";
import { ContactPage } from "@/pages/ContactPage";
import { PrivacyPage } from "@/pages/PrivacyPage";
import { NotFound } from "@/pages/NotFound";

// The design is a multi-page site (home + four services + case studies + about),
// not the single-page layout this project started as. Routes mirror the four
// menu columns in 30:262.
function App() {
    return (
        <BrowserRouter>
            <SmoothScroll />
            <Routes>
                <Route element={<SiteLayout />}>
                    <Route index element={<Home />} />
                    <Route path="servicos/:slug" element={<ServicePage />} />
                    <Route path="cases/:slug" element={<CasePage />} />
                    <Route path="sobre" element={<StudioPage />} />
                    <Route path="sobre/andre" element={<FounderPage />} />
                    <Route path="contato" element={<ContactPage />} />
                    <Route path="politica-de-privacidade" element={<PrivacyPage />} />
                    <Route path="*" element={<NotFound />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
